export default __webpack_public_path__ + "static/logo-black-08693775de162255b612d2febd7b39b0.png";